import {Component, OnInit} from '@angular/core';
import {Affiliate} from '../affiliate.model';
import {Model} from '../../../app.model';
import {AutorunComponent} from '@myshared/autorun.component';
import {AffiliateService} from '../affiliate.service';
import {I18NextService} from 'angular-i18next';
import {MessageService} from 'primeng/api';
import {CompanyService} from '../../../company/company.service';
import {BankAccount} from "../../../company/company.model";
import {FormEmitter} from "../../../forms/form.component";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {trimInput} from "@myshared/utils";

const MAX_FILESIZE_BYTES = 10485760; // 10 Mib in bytes

@Component({
    selector: 'app-become-partner',
    templateUrl: './become-partner.component.html',
    standalone: false
})
export class BecomePartnerComponent extends AutorunComponent implements OnInit {
  initialized = false;
  showVAT = false;
  companyVAT = '';
  bankAccount: BankAccount;
  hasBankAccount: boolean;

  public affiliate: Affiliate;
  public file: File = null;
  public isSepaValid = false;

  form: UntypedFormGroup;

  constructor(private m: Model,
              private affiliateService: AffiliateService,
              private messageService: MessageService,
              private companyService: CompanyService,
              private i18next: I18NextService,
              private fb: UntypedFormBuilder) {
    super();
  }

  ngOnInit() {
    this.autorun(() => {
      this.affiliate = this.m.affiliate.affiliate;
      this.companyVAT = this.m.company.company.vat;
      this.initialized = !!this.m.company.company.id;
      if (this.initialized === true){
        if (this.companyVAT === '') this.showVAT = true
      }
      
      this.hasBankAccount = this.m.company.company.hasBankAccount;
      this.bankAccount = this.hasBankAccount ? this.m.company.company.bankAccounts[0] : BankAccount.fromJson({});
      if (this.hasBankAccount) {
        this.isSepaValid = true;
      }
    });

    this.form = this.fb.group({
      vat: '',
      company_description: '',
    })

    this.companyService.refresh();
  }

  getFile(event) {
    if (event.target.files && event.target.files.length > 0) {
      this.file = null;
      const file = event.target.files[0];
      if (file.type !== 'application/pdf') {
        this.messageService.add({severity: 'error',
          summary: this.i18next.t('trading_license_wrong_filetype') as string});
        return;
      }
      if (file.size > MAX_FILESIZE_BYTES) {
        this.messageService.add({severity: 'error',
          summary: this.i18next.t('trading_license_filesize_exceeded') as string});
        return;
      }
      this.file = file;
    }
  }

  onSepaChanged(event: FormEmitter<BankAccount>) {
    this.isSepaValid = event.formGroup.valid;
    this.bankAccount.account_holder = event.data.account_holder;
    this.bankAccount.acc_number = event.data.acc_number;
  }

  send() {
    const reader = new FileReader();
    reader.onloadend = () => {
      // Result is a data uri like: data:application/pdf;base64,KV19JywKJVBERi0xLjQKMSAwI
      // Split the first part and check the mimetype
      // Then split the second part and use it to upload
      const parts = ('' + reader.result).split(','); // Need to be a string. Error at typescript > 3
      if (parts.length > 1) {
        let paymentDetails = undefined;
        if (!this.hasBankAccount) {
          paymentDetails = this.bankAccount;
        }

        let vat = undefined;
        if (!this.m.company.company.vat) {
          vat = trimInput(this.form.get('vat').value);
        }

        this.affiliateService.applyForPartnership(this.partnerDescription, parts[1], paymentDetails, vat);
      }
    };
    reader.readAsDataURL(this.file);
  }

  get partnerDescription() {
    return trimInput(this.form.get('company_description').value);
  }

  get tenantCountryCode() {
    return this.m.account.currentUser.trunkEnvironment.tenantCountryCode;
  }

  getTradingLicenseByType(type: 'text' | 'headline'): string {
    const tenantCountryCode = this.tenantCountryCode.toLowerCase();
    return `affiliate_trading_license_${type}_${tenantCountryCode}`;
  }

  get isDisabled() {
    return !this.isSepaValid || this.partnerDescription.length < 50 || !this.file || !this.form.valid;
  }

}
